import React from 'react';
import { Page, Document, Image, StyleSheet } from '@react-pdf/renderer';
import InvoiceTitle from './InvoiceTitle';
import BillTo from './BillTo';
import InvoiceNo from './InvoiceNo';
import InvoiceItemsTable from './InvoiceItemsTable';
import InvoiceSelectedItemsTable from './InvoiceSelectedItemsTable';
import InvoiceFreeItemsTable from './InvoiceFreeItemsTable';
import InvoiceThankYouMsg from './InvoiceThankYouMsg';
import logo from './logo.png';
import logo_nl from './logo_nl.png';
import main from './main.jpg';
import main_nl from './main_nl.jpg';
import OrderDetails from './OrderDetails';
import { useTranslation } from 'react-i18next';

const styles = StyleSheet.create({
	page: {
		fontFamily: 'Helvetica',
		fontSize: 11,
		paddingTop: 30,
		paddingLeft: 60,
		paddingRight: 60,
		lineHeight: 1.5,
		flexDirection: 'column',
	},
	logo: {
		width: 5 * 20,
		height: 3 * 20,
		marginLeft: 'auto',
		marginRight: 'auto',
	},
});

const Invoice = ({ invoice }) => {
	const { t, i18n } = useTranslation();
	const currentLang = i18n.language;

	return (
		<Document>
			<Page
				size='A4'
				style={styles.page}>
				<Image src={currentLang === 'nl' ? main_nl : main} />
			</Page>
			<Page
				size='A4'
				style={styles.page}>
				<Image
					style={styles.logo}
					src={currentLang === 'nl' ? logo_nl : logo}
				/>
				<InvoiceTitle title={t('offer')} />
				<InvoiceNo invoice={invoice} />
				<BillTo invoice={invoice} />
				<InvoiceItemsTable invoice={invoice} />
				<OrderDetails invoice={invoice} />
			</Page>
			<Page
				size='A4'
				style={styles.page}>
				<Image
					style={styles.logo}
					src={currentLang === 'nl' ? logo_nl : logo}
				/>
				<InvoiceTitle title={t('movingItemsList')} />
				<InvoiceSelectedItemsTable invoice={invoice} />
				<InvoiceFreeItemsTable invoice={invoice} />
				<InvoiceThankYouMsg />
			</Page>
		</Document>
	);
};

export default Invoice;
